import styled from 'styled-components';

import { Link } from '../Link/Link';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 56px 24px;
  background-color: #f5f4f8;
  text-align: center;
`;

export const Title = styled.h3`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
`;

export const Desc = styled.p`
  width: 100%;
  max-width: 680px;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const Cta = styled(Link)`
  display: flex;
  align-items: center;
  gap: 7px;
  width: fit-content;
  height: 32px;
  padding: 0 12px 0 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  border: 0 none;
  border-radius: 16px;
  transition: all 150ms;
`;
